<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <autocomplete
              v-model="group"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('group')"
              :value="group"
              type="group"
            />
          </v-col>
          <v-col
            cols="12"
            class="mb-0  "
          >
            <v-text-field
              v-model="number"
              :label="$t('code')"
              height="20"
              dense
              outlined
              type="number"
              class="mb-1 dense"
            >
              <template v-slot:append>
                <div style="margin-top: 6px">
                  {{(group ? group.number : '')}}
                </div>
              </template>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            class="mb-0"
          >
            <v-text-field
              v-model="name"
              :label="$t('caption')"
              height="20"
              dense
              outlined
              class="mb-1 dense"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="kind"
              :label="$t('type')"
              :items="kindItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <v-select
              v-model="type"
              :label="$t('nature')"
              :items="typeItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
          >
            <description
              v-model="content"
              :outlined="true"
              type="sell"
            />
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="status"
              :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
              value="active"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import Description from '../../components/general/description/Description'
  export default {
    name: 'total',
    components: {
      Snakbar,
      Description,
      autocomplete: () => import('../../components/general/patial/autocomplete'),
    },
    mixins: [General],
    props: ['item', 'groupProp'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      Description: null,
      kind: 'always',
      kindItems: null,
      number: null,
      valid: null,
      message: null,
      content: null,
      alertType: null,
      name: null,
      type: null,
      typeItems: null,
      id: null,
      status: 'active',
      level: 'total',
      group: null,
      loading: false,
    }),
    watch: {
      item (item, oldItem) {
        this.set(item)
      },
      groupProp (item, oldItem) {
        this.group = item
      },
    },
    beforeMount () {
      this.typeItems = [
        {
          value: null,
          text: this.$t('neutral'),
        },
        {
          value: 'debtor',
          text: this.$t('debtor'),
        },
        {
          value: 'creditor',
          text: this.$t('creditor'),
        },
      ]
      this.kindItems = [
        {
          value: 'always',
          text: this.$t('always'),
        },
        {
          value: 'temporary',
          text: this.$t('temporary'),
        },
      ]
    },
    mounted () {
      this.set(this.item)
      if (this.groupProp) {
        this.group = this.groupProp
      }
    },
    methods: {
      set (item) {
        if (this.item) {
          this.id = this.item.id
          this.name = this.item.name
          this.number = this.item.number
          this.type = this.item.type
          this.group = this.item.group
          this.content = this.item.content
          this.kind = this.item.kind
          this.status = this.item.status
        } else {
          this.id = null
          this.name = null
          this.number = null
          this.type = null
          this.group = this.groupProp
          this.content = null
          this.kind = null
          this.status = 'active'
        }
      },
      create () {
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'coding', app.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.kind = null
            app.content = null
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.$emit('close')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'coding/' + this.id, this.$data)
          .then(res => {
            app.name = null
            app.type = null
            app.number = null
            app.kind = null
            app.content = null
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.$emit('close')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
    },
  }
</script>

<style scoped>

</style>
